import { createAsyncThunk, createSlice, EntityState } from '@reduxjs/toolkit';
import { fetchCopyDestinationList } from 'api/layout.service';
import { projectReadActions } from 'redux/project-read/project-read.slice';
import { CopyDestinationLayoutListResponse } from 'types/entity';
import { layoutCopyReadAdapter } from './layout-copy-read.adapter';

export const LAYOUT_COPY_READ_STORE_NAME = 'layoutCopyRead';

export const loadLayoutCopyDestinationList = createAsyncThunk(
  `${LAYOUT_COPY_READ_STORE_NAME}/load`,
  async (payload: { projectId: string, sourceLayoutId: string }, _) => {
    const {
      projectId,
      sourceLayoutId,
    } = payload;
    return fetchCopyDestinationList(projectId, sourceLayoutId);
  },
);

export type LayoutCopyReadState = EntityState<CopyDestinationLayoutListResponse> & {
  sourceLayoutId: string
  loaded: boolean
  error?: any
}

export const initialLayoutCopyReadState: LayoutCopyReadState = layoutCopyReadAdapter.getInitialState({
  sourceLayoutId: '',
  loaded: false,
  error: null,
});

export const layoutCopyReadSlice = createSlice({
  name: LAYOUT_COPY_READ_STORE_NAME,
  initialState: initialLayoutCopyReadState,
  // awaitでないAction系
  reducers: {},
  // awaitするAction系
  extraReducers: (builder) => {
    builder.addCase(loadLayoutCopyDestinationList.pending, (state) => {
      layoutCopyReadAdapter.removeAll(state);
      state.loaded = false;
    });
    builder.addCase(loadLayoutCopyDestinationList.fulfilled, (state, action) => {
      layoutCopyReadAdapter.setOne(state, action.payload || {});
      state.sourceLayoutId = action.payload.source_layout.layout_id || '';
      state.loaded = true;
    });
    builder.addCase(loadLayoutCopyDestinationList.rejected, (state, action) => {
      state.sourceLayoutId = '';
      state.error = action.payload;
      state.loaded = true;
    });

    // プロジェクト切り替え時
    builder.addCase(projectReadActions.selectOne, (state) => {
      layoutCopyReadAdapter.removeAll(state);
      state.sourceLayoutId = '';
      state.loaded = false;
      state.error = null;
    });
  },
});

// Action creators are generated for each case reducer function
export const layoutCopyReadActions = {
  ...layoutCopyReadSlice.actions,
  loadLayoutCopyDestinationList,
};

export default layoutCopyReadSlice.reducer;
